import { CURRENCY_DETAILS_LIST } from "../CurrencyDetails";
export function currencySymbol(currency) {
    if (!currency)
        return;
    const details = CURRENCY_DETAILS_LIST[currency];
    if (!details) {
        return currency;
    }
    else {
        return details.nativeSymbol;
    }
}
//# sourceMappingURL=currencySymbol.js.map